import { Status } from '@/interfaces/status';
import { EntityResource } from './entity.resource';
import { StatusFilterVariables } from './queryVariables/filters/filters';

/**
 * Resource statusów
 *
 * @export
 * @class StatusResource
 * @extends {EntityResource<Status>}
 */
export class StatusResource extends EntityResource<Status> {
  public getFields = {
    id: true,
    name: true,
    type: true,
    stageId: true,
    start: true,
    color: true
  };

  public listFields = {
    id: true,
    name: true,
    type: true,
    color: true,
    stage: {
      id: true,
      name: true,
      module: {
        id: true,
        name: true
      }
    }
  };

  protected listVariables = StatusFilterVariables;

  constructor() {
    super({
      entityName: 'status'
    });
  }
}

export const statusResource = new StatusResource();
